import * as React from 'react';
import { $Image, $USCAFlag } from './styles';
import uscaFlag from '../assets/icons/USCA.svg';
export const Logo = ({ onClick, logo }) => React.createElement($Image, { onClick: onClick, src: logo, alt: 'logo' });
export const UsCaFlag = () => React.createElement($USCAFlag, { alt: 'us-ca', src: uscaFlag });
